require('client/storelocator-app.js');
